import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { sponsorTiers, site } from '../data/site';

const Sponsors: React.FC = () => (
  <>
    <section className="section">
      <Container>
        <div className="text-center">
          <h1 className="section-title">Festival Sponsors</h1>
          <hr className="section-rule" />
          <p className="lede mx-auto">
            Art on the Lake is free to the community because of the businesses, governments, and
            organizations that stand behind it. Thank you.
          </p>
        </div>
      </Container>
    </section>

    {sponsorTiers.map((tier, index) => (
      <section
        key={tier.tier}
        className={`section ${index % 2 === 0 ? 'bg-water-soft' : ''}`}
      >
        <Container>
          <div className="text-center mb-4">
            <p className="sponsor-tier-label h5 mb-2">{tier.tier}</p>
            {tier.blurb && (
              <p className="mx-auto mb-0" style={{ maxWidth: '46rem' }}>{tier.blurb}</p>
            )}
          </div>

          <Row className="g-4 justify-content-center align-items-center">
            {tier.sponsors.map((sponsor) => (
              <Col xs={12} sm={6} lg={4} key={sponsor.name} className="text-center">
                <div className="bg-white border p-4 h-100 d-flex flex-column justify-content-center align-items-center">
                  {sponsor.logo && (
                    <img className="sponsor-logo mb-3" src={sponsor.logo} alt={sponsor.name} />
                  )}
                  {sponsor.url ? (
                    <a href={sponsor.url} target="_blank" rel="noopener noreferrer">
                      {sponsor.name}
                    </a>
                  ) : (
                    <span>{sponsor.name}</span>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    ))}

    <section className="section bg-navy text-white text-center">
      <Container>
        <h2 className="section-title text-white">Interested in sponsoring?</h2>
        <hr className="section-rule" />
        <p className="mb-0">
          Email <a href={`mailto:${site.email}`} className="text-water">{site.email}</a> or call{' '}
          <a href={site.phoneHref} className="text-water">{site.phone}</a>.
        </p>
      </Container>
    </section>
  </>
);

export default Sponsors;
